
(() => {
  const selector =
    '.pf-studio-options-panel input[data-setting][type="text"][inputmode="decimal"]';

  function validateDecimal(event) {
    const input = event.target;

    if (!(input instanceof HTMLInputElement) ||
        !input.matches(selector)) return;

    // Convert Finnish/Swedish commas into decimal dots.
    const normalized = input.value.replace(/,/g, ".");

    if (input.value !== normalized) {
      const cursor = input.selectionStart;
      input.value = normalized;

      if (cursor !== null) {
        input.setSelectionRange(cursor, cursor);
      }
    }

    const text = input.value.trim();
    const number = Number(text);
    const min = input.hasAttribute("min")
      ? Number(input.getAttribute("min")) : -Infinity;
    const max = input.hasAttribute("max")
      ? Number(input.getAttribute("max")) : Infinity;

    let invalid =
      !text ||
      !/^-?(?:\d+(?:\.\d*)?|\.\d+)$/.test(text) ||
      !Number.isFinite(number) ||
      number < min ||
      number > max;

    // Preserve step increments such as 0.5 and 0.05.
    const step = input.getAttribute("step");

    if (!invalid && step && step !== "any") {
      const increment = Number(step);

      if (Number.isFinite(increment) && increment > 0) {
        const base = Number.isFinite(min) ? min : 0;
        const steps = (number - base) / increment;

        invalid =
          Math.abs(steps - Math.round(steps)) > 0.000001;
      }
    }

    input.setCustomValidity(
      invalid ? "Enter a valid number within the allowed range." : ""
    );
  }

  // Capture before the studio's normal input handlers run.
  document.addEventListener("input", validateDecimal, true);
  document.addEventListener("change", validateDecimal, true);
})();
